import { apiEndpoints } from "../../constants";
import { BaseService } from "./baseService";

class SquareServices extends BaseService {
  async createPayment(
    request_id: number,
    token: string,
    amount: number,
    currency: string
  ): Promise<any> {
    try {
      const response = await this.post(
        apiEndpoints.PAYMENT.SQUARE.CREATE_PAYMENT,
        {
          request_id: request_id,
          source_id: token,
          amount: amount,
          currency: currency,
        }
      );
      // if (!response.ok) {
      //   const errorBody = await response.text();
      //   throw new Error(
      //     `Payment Failed: ${response.status} ${response.statusText} - ${errorBody}`
      //   );
      // }

      return response;
    } catch (error) {
      console.error("Square Payment Error:", error);
      throw error;
    }
  }
}

const squareServices = new SquareServices();
export default squareServices;
